import styled from 'styled-components';
import { baseTheme } from '../../../../../../global/styles/theme';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Modal = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  width: 90%;
  max-width: 560px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  & .title {
    font-size: 16px;
    font-weight: 600;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  line-height: 1;
  color: ${() => baseTheme.colors.mainBlue};

  &:hover {
    opacity: 0.7;
  }
`;

export const ProductInfo = styled.div`
  font-size: 13px;
  color: #666;

  & strong {
    color: ${() => baseTheme.colors.mainBlue};
  }
`;

export const CurrentProposal = styled.div`
  padding: 10px 14px;
  background: #f0f4ff;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;

  & .proposal-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  & .proposal-name {
    font-weight: 600;
  }

  & .proposal-price {
    color: #666;
  }
`;

export const RemoveButton = styled.button`
  background: #fee;
  border: 1px solid #fcc;
  border-radius: 6px;
  padding: 4px 10px;
  cursor: pointer;
  color: #c00;
  font-size: 12px;
  flex-shrink: 0;

  &:hover {
    background: #fdd;
  }
`;

export const SearchRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: stretch;
`;

export const SearchInput = styled.input`
  flex: 1;
  padding: 10px 14px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;

  &:focus {
    border-color: ${() => baseTheme.colors.focus};
  }
`;

export const SearchButton = styled.button<{ disabled?: boolean }>`
  padding: 10px 18px;
  background: ${({ disabled }) => (disabled ? '#eee' : '#6B4EFF')};
  color: ${({ disabled }) => (disabled ? '#999' : '#fff')};
  border: none;
  border-radius: 8px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }
`;

export const LimitHint = styled.span`
  color: ${() => baseTheme.colors.error};
  font-size: 11px;
`;

export const LoadingText = styled.div`
  text-align: center;
  color: #999;
  font-size: 13px;
`;

export const EmptyText = styled.div`
  text-align: center;
  color: #999;
  font-size: 13px;
`;

export const ResultsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;
`;

export const ProductCard = styled.div<{
  isSelected: boolean;
  isDisabled: boolean;
}>`
  display: flex;
  gap: 12px;
  padding: 10px 12px;
  border: 1px solid ${({ isSelected }) => (isSelected ? '#6B4EFF' : '#eee')};
  border-radius: 10px;
  background: ${({ isSelected, isDisabled }) => {
    if (isSelected) return '#f5f0ff';
    if (isDisabled) return '#fafafa';
    return '#fff';
  }};
  opacity: ${({ isDisabled }) => (isDisabled ? 0.5 : 1)};
  transition: border-color 0.15s;
`;

export const ProductImage = styled.img`
  object-fit: contain;
  border-radius: 6px;
  flex-shrink: 0;
  width: 64px;
  height: 64px;
`;

export const ProductDetails = styled.div`
  flex: 1;
  min-width: 0;

  & .product-name {
    font-size: 13px;
    font-weight: 500;
    margin-bottom: 2px;
  }

  & .product-meta {
    font-size: 12px;
    color: #888;
    margin-bottom: 4px;
  }

  & .product-price {
    font-size: 13px;
    font-weight: 600;
    color: ${() => baseTheme.colors.mainBlue};
    margin-bottom: 6px;

    & .product-stock {
      font-weight: 400;
      color: #888;
      margin-left: 8px;
      font-size: 12px;
    }
  }
`;

export const CounterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CounterButton = styled.button<{ disabled?: boolean }>`
  width: 28px;
  height: 28px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #fff;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;

  &:hover:not(:disabled) {
    border-color: #6b4eff;
    color: #6b4eff;
  }
`;

export const CounterValue = styled.span`
  min-width: 24px;
  text-align: center;
  font-size: 14px;
`;

export const CounterTotal = styled.span`
  font-size: 12px;
  color: #888;
`;

export const InlineRemoveButton = styled.button`
  margin-left: auto;
  background: none;
  border: none;
  color: #f44336;
  cursor: pointer;
  font-size: 12px;

  &:hover {
    text-decoration: underline;
  }
`;

export const SelectButton = styled.button<{ disabled?: boolean }>`
  padding: 5px 14px;
  background: ${({ disabled }) => (disabled ? '#eee' : '#6B4EFF')};
  color: ${({ disabled }) => (disabled ? '#999' : '#fff')};
  border: none;
  border-radius: 6px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  font-size: 13px;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }
`;

export const ConfirmButton = styled.button`
  padding: 10px;
  background: #6b4eff;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  width: 100%;

  &:hover {
    opacity: 0.9;
  }
`;
